import { Box } from "@mui/material";
import Layout from "../../layout";

export default function AnalyticsScreen() {
  return (
    <Layout>
      <Box
        component="iframe"
        src="https://bi.voltreum.com/"
        sx={{
          width: "100%",
          height: "calc(100vh - 150px)",
          border: "none",
        }}
        title="Voltreum Dashboard"
      />
    </Layout>
  );
}
